import {
  IconBuilding,
  IconChartLine,
  IconFileText,
  IconHistory,
  IconLayoutGrid,
  IconListCheck,
  IconMail,
  IconShieldCheck,
} from '@tabler/icons-react';

export type DebtorTabKey =
  | 'overzicht'
  | 'posten'
  | 'mailbox'
  | 'acties'
  | 'betaalgedrag'
  | 'risico-krediet'
  | 'bedrijfsgegevens'
  | 'historie';

export type DebtorTab = {
  key: DebtorTabKey;
  label: string;
  icon: typeof IconLayoutGrid;
};

export const DEBTOR_TABS: DebtorTab[] = [
  { key: 'overzicht', label: 'Overzicht', icon: IconLayoutGrid },
  { key: 'posten', label: 'Posten', icon: IconFileText },
  { key: 'mailbox', label: 'Mailbox', icon: IconMail },
  { key: 'acties', label: 'Acties', icon: IconListCheck },
  { key: 'betaalgedrag', label: 'Betaalgedrag', icon: IconChartLine },
  { key: 'risico-krediet', label: 'Risico & krediet', icon: IconShieldCheck },
  { key: 'bedrijfsgegevens', label: 'Bedrijfsgegevens', icon: IconBuilding },
  { key: 'historie', label: 'Historie', icon: IconHistory },
];

export function isDebtorTabKey(value: unknown): value is DebtorTabKey {
  return DEBTOR_TABS.some((tab) => tab.key === value);
}

// Waar de gebruiker de debiteur vandaan opende. Zonder herkomst komt hij uit de
// Debiteuren-tabel. Bepaalt de breadcrumb, de terugknop en het actieve menu-item.
export type DebtorOrigin = 'acties-openstaand' | 'acties-monitoring' | 'mailbox';

const DEBTOR_ORIGINS: DebtorOrigin[] = ['acties-openstaand', 'acties-monitoring', 'mailbox'];

export function isDebtorOrigin(value: unknown): value is DebtorOrigin {
  return DEBTOR_ORIGINS.includes(value as DebtorOrigin);
}

export const DEBTOR_ORIGIN_NAV_PATH: Record<DebtorOrigin, '/acties' | '/mailbox'> = {
  'acties-openstaand': '/acties',
  'acties-monitoring': '/acties',
  mailbox: '/mailbox',
};
